// extracted by mini-css-extract-plugin
export default {"wellDone":"WellDone_wellDone__g6vg4","praise":"WellDone_praise__cP6Lq","lottieContainer":"WellDone_lottieContainer__zWw+O","lottie":"WellDone_lottie__KpWv8"};